<template>
  <v-btn-form :title="title" @close="cancel()">
    <v-card-text>
      <v-text-field
        label="Введите запрос"
        v-model="filterString"
        clearable
        persistent-hint
      ></v-text-field>
      <v-flex>
          <v-select
            label="Категория"
            v-model="path"
            :hint="getDisplayPathByPath(path)"
            :items="getDisplayPaths()"
            item-value="key"
            item-text="value"
            clearable
          >
         <template slot="item" slot-scope="data">
            <span :style="styleItem(data.item)">{{data.item.value}}</span>
          </template>  
          </v-select>

      </v-flex>
    </v-card-text>
      <v-card-scroll flat :height="calcDialogScroll(48+168+52)">
      <v-list :three-line="true" dense>
        <template v-for="item in this.filteredItems">
          <v-subheader v-if="item.header" v-text="item.header"></v-subheader>
          <v-divider v-else-if="item.divider" v-bind:inset="item.inset"></v-divider>
          <v-list-tile v-else v-bind:key="item.value" @click="select(item.value)">
             <v-list-tile-content style="justify-content: start;">
              <b>{{item.text}}</b>
               <v-list-tile-sub-title> 
               <span style="white-space: normal;"> {{item.description}}</span>
             </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>   
            <v-icon v-show="check(item.value)">radio_button_checked</v-icon>           
            <v-icon v-show="!check(item.value)">radio_button_unchecked</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
    </v-card-scroll>      
    <template #actions>
      <v-btn :disabled='!itemId' @click="ok">ОК</v-btn>
      <v-spacer></v-spacer>
    </template>  
  </v-btn-form>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import formats from '../../api/formats'
  import vCardScroll from '../common/CardScroll'
  import vBtnForm from '../common/BtnForm'

  export default {
    name: 'deed-selector',
    components: {vCardScroll, vBtnForm},
    data: () => ({
      valid: false,
      path: '/',
      itemId: null,
      filterString: null
    }),
    mounted () {
      this.$store.dispatch('fetchDeeds')
      this.filterString = this.query
    },
    watch: {
    },
    props: {
      fullscreen: {
        type: Boolean,
        default: false
      },
      query: {
        type: String,
        default: null
      },
      bindersOnly: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapGetters({
        calcDialogScroll: 'calcDialogScroll',
        getAssistDeedsByPath: 'getAssistDeedsByPath',
        getAssistDeedFolders: 'getAssistDeedFolders'
      }),
      title () {
        return this.bindersOnly && 'Выберите тип подшивки' || 'Выберите тип документа'
      },
      items () {
        let result = this.getAssistDeedsByPath(this.path)
        if (!this.bindersOnly) {
          return result
        }
        let re = new RegExp('BINDER:', 'i')
        return result.filter(d => re.test(d.value))
      },
      orderedItems () {
        return this.items.sort((a, b) => formats.compareString(a.text, b.text))
      },
      filteredItems () {
        const getSearchString = (item) => {
          return ''
            .concat(
              item.value,
              item.text,
              item.description)
        }

        var filter = (this.filterString === null) || (this.filterString.length < 1) ? null : this.filterString.toUpperCase()
        if (!filter) {
          return this.orderedItems
        }
        return this.orderedItems.filter(item => getSearchString(item).toUpperCase().includes(filter))
      }
    },
    methods: {
      ok () {
        this.$emit('input', this.itemId)
        this.cancel()
      },
      cancel () {
        this.$emit('close')
        this.itemId = null
      },
      getDisplayPathByPath (path) {
        if (!path) {
          return null
        }
        var currPath = ''
        var currDisplayPath = ''
        var paths = path.split('/')
        paths.pop()
        for (var i = 1; i < paths.length; i++) {
          currPath = currPath + '/' + paths[i]
          var folder = this.getAssistDeedFolders.find(f => f.value === currPath)
          if (folder) {
            currDisplayPath = currDisplayPath + ' /' + folder.text
          }
        }
        return currDisplayPath
      },
      getDisplayPaths () {
        var map = this.getAssistDeedFolders
        var result = []
        if (!map) {
          return result
        }
        map.forEach((i) => {
          // var shift = i.value.replace(/\//g, '').replace(/\d/g, '')
          result.push({key: i.value, value: i.text})
        })
        return result
        // return result.sort((a, b) => a.value.localeCompare(b.value))
      },
      styleItem (item) {
        var margin = item && item.key && item.key.replace(/\d/g, '').length - 1 + 'em' || '0em'
        return 'margin-left: ' + margin
      },
      select (uid) {
        this.itemId = this.itemId !== uid ? uid : null
      },
      check (uid) {
        return uid === this.itemId
      }
    }

  }

</script>




// WEBPACK FOOTER //
// DeedSelector.vue?7ea4940d